import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { collection, doc, getDoc } from 'firebase/firestore';
import { firestore } from '@/utils/firebase';
import BASE_QUERY from '@/features/baseQuery';

// Creating an API service using RTK Query
export const formsApi = createApi({
	reducerPath: 'formsApi',
	tagTypes: ['FORMS',],
	baseQuery: fetchBaseQuery(BASE_QUERY),
	endpoints: (builder) => ({
		getForms: builder.query({
			query: ({dealPipeline = null, brokerRef}) => ({
				url: process.env.REACT_APP_GET_ALL_FORMS,
				method: 'POST',
				body: { type: dealPipeline, brokerRef: brokerRef }
			}),
			transformResponse: (response) => {
				console.log('👾 ~ transform getForms response', response);
				return response;
			},
		}),
	}),
});

// Exporting auto-generated hooks for the defined endpoints
export const { useGetFormsQuery } = formsApi;